<template lang="pug">
v-dialog(v-model="dialog", max-width="400px")
  v-card
    v-card-title
      span.headline {{ title }}
    v-card-text {{ message }}
    v-card-actions
      v-spacer
      v-btn(
        v-if="type === 'alert'",
        color="primary",
        text,
        @click="dialog = false"
      ) OK
      template(v-else)
        v-btn(
          color="danger",
          text,
          @click="handleConfirm(false)"
        ) Cancelar
        v-btn(
          color="primary",
          text,
          @click="handleConfirm(true)"
        ) Confirmar
</template>

<script>
export default {
  name: "MessageModal",
  data() {
    return {
      dialog: false,
      title: "",
      message: "",
      type: "alert",
      callback: null,
    };
  },
  methods: {
    showMessage({ title, message, type = "alert", callback = null }) {
      this.title = title;
      this.message = message;
      this.type = type;
      this.callback = callback;
      this.dialog = true;
    },
    handleConfirm(confirmed) {
      if (this.callback) {
        this.callback(confirmed);
      }
      this.dialog = false;
    },
  },
  created() {
    this.$root.$on("showMessage", this.showMessage);
  },
  beforeDestroy() {
    this.$root.$off("showMessage", this.showMessage);
  },
mounted() {
  this.$root.$on("showMessage", this.showMessage);
}
};
</script>
